import React from "react";
import { getDesiredBoundryChart } from "src/Requests/deltaHedgeAccounts";
import {
  IDeltaHedgeAccountAggregateReport,
  ChartData,
} from "src/Interfaces/deltaHedgeAccounts";
import ScatterLineChart from "src/Components/Charts/ScatterLineChart";

interface IProps {
  row: IDeltaHedgeAccountAggregateReport;
}

const PreferredBorderChart: React.FC<IProps> = ({ row }) => {
  const [chartData, setChartData] = React.useState<ChartData>();

  React.useEffect(() => {
    getDesiredBoundryChart({
      deltahedgeAccountId: row?.deltahedgeAccountId,
      sahraUserId: row?.accountId,
      dei: row?.dei,
      te: row?.te,
      groupId: row?.groupId,
    }).then((res) => {
      setChartData(res);
    });
  }, []);

  return (
    <div className="w-full h-full justify-center items-center align-middle relative">
      <ScatterLineChart
        series={chartData?.series || []}
        titleX={chartData?.titleX}
        titleY={chartData?.titleY}
      />
    </div>
  );
};

export default PreferredBorderChart;
